import { Box, Button, CardActions, CircularProgress } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import React from 'react';

type SurveyQuestionFooterProps = {
    onSave: () => Promise<void>;
    isFetching: boolean,
    optionSelected: boolean,
};

const SurveyQuestionFooter: React.FC<SurveyQuestionFooterProps> = ({
    onSave,
    isFetching,
    optionSelected,
}) => {
    return (
        <CardActions sx={{
            display: "flex",
            width: "100%",
            justifyContent: 'center',
            position: 'sticky',
            bottom: 0,
            bgcolor: 'background.paper'
        }}>
            <Button
                onClick={onSave}
                sx={{ width: '100%', fontWeight: 'bold', backgroundColor: "#355ADD", 
                    '&:hover': {
                        backgroundColor: '#5C79E6',
                    }, }}
                variant='contained'
                disabled={isFetching || !optionSelected}
                endIcon={isFetching ? <CircularProgress size="20px" /> : <NavigateNextIcon />}
            >Continue
            </Button>
        </CardActions>
    );
};



export default SurveyQuestionFooter;